<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <!-- Card stats -->
            <div class="row">
                
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Número de ejercicios"
                                type="gradient-orange"
                                :sub-title="count_ejercicios"
                                icon="ni ni-chart-pie-35"
                                class="mb-4 mb-xl-0">

                        <template slot="footer">
                            <span class="text-success mr-2"></span>
                            <span class="text-nowrap"></span>
                        </template>
                    </stats-card>
                </div>
                
            </div>
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <card header-classes="bg-transparent" class="align-items-end">
                        <base-dropdown position="right">
                        <base-button @click="track" slot="title" type="primary" class="dropdown-toggle">
                            Índice
                        </base-button>
                            <a class="dropdown-item" href="#pectoral">1.- Pectoral</a>
                            <a class="dropdown-item" href="#espalda">2.- Espalda</a>
                            <a class="dropdown-item" href="#biceps">3.- Bíceps</a>
                            <a class="dropdown-item" href="#triceps">4.- Tríceps</a>
                            <a class="dropdown-item" href="#hombro">5.- Hombro</a>
                            <a class="dropdown-item" href="#trapecio">6.- Trapecio</a>
                            <a class="dropdown-item" href="#abdominales">7.- Abdominales</a>
                            <a class="dropdown-item" href="#lumbares">8.- Lumbares</a>
                            <a class="dropdown-item" href="#piernas">9.- Piernas</a>
                            <a class="dropdown-item" href="#cardio">10.- Cardio</a>
                        </base-dropdown>
                    </card>
                    
                    <ejercicios-table title="Ejercicios de pectoral" category="pectoral" id="pectoral"></ejercicios-table>
                    <ejercicios-table title="Ejercicios de espalda" category="espalda" id="espalda"></ejercicios-table>
                    <ejercicios-table title="Ejercicios de bíceps" category="biceps" id="biceps"></ejercicios-table>
                    <ejercicios-table title="Ejercicios de tríceps" category="triceps" id="triceps"></ejercicios-table>
                    <ejercicios-table title="Ejercicios de hombro" category="hombro" id="hombro"></ejercicios-table>
                    <ejercicios-table title="Ejercicios de trapecio" category="trapecio" id="trapecio"></ejercicios-table>
                    <ejercicios-table title="Ejercicios de abdominales" category="abdominales" id="abdominales"></ejercicios-table>
                    <ejercicios-table title="Ejercicios de lumbares" category="lumbares" id="lumbares"></ejercicios-table>
                    <ejercicios-table title="Ejercicios de piernas" category="piernas" id="piernas"></ejercicios-table>
                    <ejercicios-table title="Ejercicios de cardio" category="cardio" id="cardio"></ejercicios-table>
                </div>
            </div>
            
        </div>

    </div>
</template>
<script>
  import { db } from '../../firebaseDb';
  import EjerciciosTable from '../Tables/EjerciciosTable'
  export default {
    name: 'list_ejercicios',
    components: {
      EjerciciosTable
    },
    data(){
        return{
        count_ejercicios: "0"
        }
    },
    created: function(){
        db.collection('ejercicios').get()
            .then(snapshot => this.count_ejercicios = snapshot.size.toString());
    },
    methods: {
      track() {
        this.$gtag.event("index_exercise", {
          'event_category': "exercise",
          'event_label': "exercise_index",
          'value': 1
        })
      },
    }
  };
</script>
<style></style>
